<template>
    <div>
        <div v-if="isLoading" class="loader-overlay">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
                <div class="menu-margin-top">
                    <div class="row ml-0 ">
                        <div class="col-lg-7 col-sm-12 mt-3">
                            <h3 class="mb-0">Black Book Analysis</h3>
                        </div>
                    </div>
                    <div class="row px-3 mt-4">
                        <div class="col-10 gap-4">
                        <ul class="tab-list d-flex gap-4 flex-wrap">
                            <li
                              class="tab-item mr-2"
                              :class="{ active: activeTab === 'records' }"
                              @click="setActiveTab('records')"
                            >Records</li>
                            <li
                              class="tab-item mr-2"
                              :class="{ active: activeTab === 'execute' }"
                              @click="setActiveTab('execute')"
                            >Execute</li>
                        </ul>
                        </div>
                        <div class="col-lg-2 col-sm-12 activitySearch tableFilterAction align-items-baseline">
                            <b-dropdown v-if="activeTab === 'records'"
                                ref="filterDropdown"
                                id="filter-dropdown" 
                                :text="'Filter'" 
                                variant="outline-secondary"
                                class="filter-btn-dropdown"
                                right
                                no-caret
                            >
                                <div class="comm-dropdown filterMenuOuter">
                                    <div class="form-wrap">
                                        <div class="d-flex filter-header mb-20">
                                            <h3 class="flex-grow-1">Filter by</h3>
                                            <button 
                                                type="button"
                                                class="btn-link p-0 close-btn" 
                                                @click.stop="closeFilterMenu"
                                                aria-label="Close"
                                            >
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                                                </svg>
                                            </button>
                                        </div>

                                        <div class="form-row">
                                            <div class="inputBox">
                                                <label class="form-label">Date</label>
                                                <div class="dateRangeBox d-flex gap-4">
                                                    <div class="date-input-wrapper" style="flex: 1;">
                                                        <input 
                                                            type="date" 
                                                            class="form-control" 
                                                            v-model="startDate"
                                                            placeholder="Start Date"
                                                            :max="endDate || new Date().toISOString().split('T')[0]"
                                                        >
                                                    </div>
                                                    <div class="date-input-wrapper" style="flex: 1;">
                                                        <input 
                                                            type="date" 
                                                            class="form-control" 
                                                            v-model="endDate"
                                                            placeholder="End Date"
                                                            :min="startDate"
                                                            :max="new Date().toISOString().split('T')[0]"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="filterBtnHolder">
                                            <button 
                                                type="button"
                                                class="btn btn-primary" 
                                                @click.stop="applyFilter"
                                                :disabled="startDate === '' && endDate === ''"
                                                :class="{ 'disabled-btn': startDate === '' && endDate === '' }"
                                            >
                                                Apply Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </b-dropdown>
                            <button v-if="activeTab === 'records'"
                                                type="button"
                                                class="btn filter-btn-dropdown exportBtn ml-2" 
                                                @click.stop="resetFilter"
                                                :disabled="startDate === '' && endDate === ''"
                                                :class="{ 'disabled-btn': startDate === '' && endDate === '' }"
                                            >
                                                Reset
                                            </button>
                        </div>
                    </div>
                    <div class="row tableContainer pb-4 pr-3 ml-0 mt-4 ">
                        <div v-if="showError" class="col-12 text-danger text-center" role="alert">{{errorMessage}}</div>
                      <div class="col-12" v-if="activeTab === 'records'">
                        <table class="table  mt-2 customerTable">
                          <thead class="tableHeading">
                              <tr>
                              <th style="width:12%">Created At</th>
                              <th style="width:15%">UVC Report File</th>
                              <th style="width:15%">UVC Report Summary File</th>
                              <th style="width:15%">Failed Summary File</th>
                              <th style="width:35%">Note</th>
                              <th style="width:8%" class="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody >
                               <tr v-for="(file, index) in blackBookFilesData" :key="file.id">
                                <td class="tableMobile align-middle">{{ formatDate(file.createdAt) }}</td>
                                <td class="tableName align-middle">{{ file.uvcReportFile || '-' }}</td>
                                <td class="tableName align-middle">{{ file.uvcReportSummaryFile || '-' }}</td>
                                <td class="tableName align-middle">{{ file.failureSummaryFile || '-' }}</td>
                                <td class="tableEmail align-middle">
                                  <div v-if="editingNoteId !== file.id" class="d-flex align-items-center gap-2" >
                                    <span class="note-text">{{file.note}}
                                        <button 
                                      type="button"
                                      class="btn-link p-0 edit-note-btn ml-2" 
                                      @click="editNote(file)"
                                      aria-label="Edit Note"
                                      title="Edit Note"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/>
                                      </svg>
                                    </button>
                                    </span>
                                  </div>
                                  <div v-else class="d-flex align-items-center gap-2 note-edit-wrapper">
                                    <input 
                                      type="text" 
                                      class="form-control note-edit-input" 
                                      v-model="editingNoteValue"
                                      @keyup.enter="updateNote(file)"
                                      @keyup.esc="cancelEdit"
                                      :ref="`noteInput-${file.id}`"
                                      maxlength="500"
                                    />
                                    <button 
                                      type="button"
                                      class="btn btn-primary btn-sm update-note-btn mx-2" 
                                      @click="updateNote(file)"
                                    >
                                      Update
                                    </button>
                                    <button 
                                      type="button"
                                      class="btn btn-secondary btn-sm cancel-note-btn" 
                                      @click="cancelEdit"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </td>
                                 <td class="tableMobile align-middle">
                                     <div class="d-flex align-items-center gap-2 justify-content-center action-inner">
                                        <select placeholder="Select File" class="form-control mr-1" v-model="selectedFileName[index]" @change="downloadFile(file, index)">
                                      <option value="" disabled selected>Download File</option>
                                      <option v-if="file.uvcReportFileLink" value="uvcReportFile">UVC Report File</option>
                                      <option v-if="file.uvcReportSummaryFileLink" value="uvcReportSummaryFile">UVC Report Summary File</option>
                                      <option v-if="file.failureSummaryFileLink" value="failureSummaryFile">Failed Summary File</option>
                                    </select>
                                     </div>
                                  </td>
                              </tr>
                          </tbody>
                        </table>
                        
                      </div>
                      <div class="col-12" v-if="activeTab === 'execute'">
                            <iframe
            :src="page"
            width="100%"
            height="980px"
            id="receiver"
            style="position:relative;z-index:0;"
            name="myIframe"
          ></iframe>
                      </div>
                    </div>
                </div>
                <div class="mt-5 mb-5 pb-3">
                        <b-pagination align="center" v-if="rows>perPage && blackBookFilesData.length>0"
                         v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-number
                        last-number
                        @input="pagination"
                        class="customPagination"
                        ></b-pagination>
                </div>
                <bottom-footer></bottom-footer>
            </div>
        </div>
    </div>
    </template>
    <script>
    import TopHeader from "@/components/TopHeader.vue";
    import MainMenu from "@/components/Menu.vue";
    import BottomFooter from "@/components/BottomFooter.vue";
    import httpcommon from "../js/http-common.js";
    import moment from "moment";
    export default {
      components: {
        MainMenu,
        TopHeader,
        BottomFooter,
      },
      name: "blackBookAnalysis",
    
      data() {
      return {
        activeTab: 'records',
        page: '',
        blackBookFilesData: [],
        noResult: '',
        isLoading: false,
        rows: 0,
        currentPage: 1,
        perPage: 10,
        selectedFileName: [],
        startDate: '',
        endDate: '',
        isExportSuccess: false,
        exportSuccess: '',
        exportError: '',
        editingNoteId: null,
        editingNoteValue: '',
        errorMessage: '',
        showError: false,
      }
      },
      computed: {
      },
      methods: {
        setActiveTab(tab) {
          this.activeTab = tab;
          this.currentPage = 1;
          this.perPage = 10;
          this.startDate = '';
          this.endDate = '';
          this.editingNoteId = null;
          this.editingNoteValue = '';
          this.showError = false;
          this.errorMessage = '';
          if(tab === 'records') {
            this.page = '';
            this.getBlackBookFilesList();
          } else if(tab === 'execute') {
            this.page = this.readTextFile('./blackbooklink.txt');
            // this.onLoadIframe();
          }
        },
    readTextFile (file) {
      // read external properties file
      var allText
      var rawFile = new XMLHttpRequest()
      rawFile.open('GET', file, false)
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status == 0) {
            allText = rawFile.responseText
            console.log(allText)
          }
        }
      }
      rawFile.send(null)
      return allText
    },
        getBlackBookFilesList () {
            this.isLoading = true
            this.noResult = ''
            this.blackBookFilesData = []
            let searchParams = new URLSearchParams()
            if(this.startDate) {
                searchParams.append('fromDate',this.startDate)
            }
            if(this.endDate) {
                searchParams.append('toDate',this.endDate)
            }
             httpcommon.get(`/api-black-book/get-files?${searchParams.toString()}&page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
                this.isLoading = false
                if(response && response.data.data) {
                    const blackBookFiles = response.data.data.content.map(file =>
                      ({
                        ...file,
                        // uvcReportFile: file.uvcReportFileLink ? file.uvcReportFileLink.split('/').pop().replace(/\.[^/.]+$/, '') : '',
                        // uvcReportSummaryFile: file.uvcReportSummaryFileLink ? file.uvcReportSummaryFileLink.split('/').pop().replace(/\.[^/.]+$/, '') : '',
                        // failureSummaryFile: file.failureSummaryFileLink ? file.failureSummaryFileLink.split('/').pop().replace(/\.[^/.]+$/, '') : '',
                        uvcReportFile: 'UVC File',
                        uvcReportSummaryFile: 'UVC Summary',
                        failureSummaryFile: 'UVC Errors File'
                      })
                    );
                    
                    this.blackBookFilesData = blackBookFiles;
                    // Initialize per-row selected file type to csv by default
                    this.selectedFileName = blackBookFiles.map(() => '');
                    this.rows = response.data.data.totalElements;
                    console.log(this.blackBookFilesData, 'blackBookFiles');
                } else {
                    this.noResult = response.data.message || 'No black book files found'
                }   
            }).catch(error=>{
                this.isLoading = false
                console.log(error)
            })
        },
        pagination () {
          this.getBlackBookFilesList();
        },
        
        isActiveRoute(route) {
          return this.$route.path === route;
        },
         downloadFile(file, index) {
             const fileName = this.selectedFileName[index];
             if(fileName === 'uvcReportFile') {
                window.open(file.uvcReportFileLink);
            } else if(fileName === 'uvcReportSummaryFile') {
                window.open(file.uvcReportSummaryFileLink);
            } else if(fileName === 'failureSummaryFile') {
                window.open(file.failureSummaryFileLink);
            }
        },
        formatDate(date) {
          return moment(date).format("DD MMM YYYY, hh:mm A");
        },
        editNote(file) {
            this.editingNoteId = file.id;
            this.editingNoteValue = file.note || '';
            this.$nextTick(() => {
                const inputRef = `noteInput-${file.id}`;
                const input = this.$refs[inputRef];
                if (input) {
                    if (Array.isArray(input)) {
                        input[0].focus();
                    } else {
                        input.focus();
                    }
                }
            });
        },
        updateNote(file) {
            if (this.editingNoteId === file.id) {
                const updatedNote = this.editingNoteValue.trim();
                httpcommon.put(`/api-black-book/update-file-note/${file.id}`, { note: updatedNote }).then(response => {
                   if(response && response.data.success) {
                    this.getBlackBookFilesList();
                    this.cancelEdit();
                    this.showError = false;
                    this.errorMessage = '';
                   }
                }).catch(error => {
                    console.log(error, 'error');
                    const backendMessage = error.response.data.message || error.response.data.error;
                    this.errorMessage = backendMessage || error.message || 'Failed to update note';
                    this.showError = true;
                });
            }
        },
        cancelEdit() {
            this.editingNoteId = null;
            this.editingNoteValue = '';
            this.showError = false;
            this.errorMessage = '';
        },
        retrieveData: function () {
          httpcommon
            .get("/userrole/")
            .then((response) => {
              this.userroles = response.data;
            })
            .catch((e) => {
              console.log(e);
              this.errorslist.push(e);
            });
          httpcommon
            .get("/staticdata/status/")
            .then((response) => {
              this.status = response.data;
            })
            .catch((e) => {
              this.errorslist.push(e);
            });
        },
        myFunction() {
          var elmnt = document.getElementById("height2");
          var elmnt1 = document.getElementById("height3");
          var txt = elmnt.offsetHeight;
          var width = elmnt.offsetWidth;
          var txt1 = elmnt1.offsetHeight;
          var ht = txt + txt1;
          $("#employee").css("margin-top", txt + txt1 + 3);
        },
        menuheight () {
          var elmnt = document.getElementById("height2");
          var txt = elmnt.offsetHeight;
          $('#height3').css('margin-top', txt)
        },
        
        resetFilter() {
          this.currentPage = 1;
          this.perPage = 10;
          this.startDate = '';
          this.endDate = '';
          this.getBlackBookFilesList();
        },
        applyFilter() {
          this.currentPage = 1;
          this.perPage = 10;
          this.getBlackBookFilesList();
        },
        closeFilterMenu() {
          // Close the filter dropdown
          if (this.$refs.filterDropdown) {
            this.$refs.filterDropdown.hide();
          }
        },
        
      },
      created () {
        window.addEventListener('resize', this.myFunction)
        window.addEventListener('resize', this.menuheight)
      },
      mounted () {
        this.myFunction()
        this.menuheight()
        this.getBlackBookFilesList()
      },
    }
</script>
<style scoped>
    .customerTable {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      /* line-height: 32px; */
      table-layout: auto;
      width: 100%;
    }
    .customerTable thead tr {
      color: #000000;
      background: #E1E4E7;
      font: 600 12px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      /* line-height: 32px; */
    }
    .customerTable thead tr th {
        border-top: none;
        white-space: nowrap;
    }
    .customerTable tbody tr td {
      font-size: 14px;
      font-weight: 600;
      color: #2C2C2C;
      border-top: none;
      /* white-space: nowrap; */
      vertical-align: middle;
    }
.action-inner {
  width: 100%;
  justify-content: center;
}
.action-inner select,
.action-inner button {
  width: 100%;
}

@media (max-width: 1200px) {
  .action-inner {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .action-inner select,
  .action-inner button {
    width: 100%;
    margin: 0 !important;
  }
}
    .tab-list {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    .tab-item {
      display: inline-block;
      font-weight: 600;
      color: #6F6F6F;
      cursor: pointer;
      padding: 6px 0;
      border-bottom: 2px solid transparent;
      transition: color 0.5s ease-in-out, border-color 0.5s ease-in-out;
    }
    .tab-item.active {
      color: #005DF1;
      border-bottom-color: #005DF1;
    }
    tbody tr {
      border-bottom: 1px solid #dbdbdb;
    }
    .mergeStatus {
        color: #00AA00 !important;
    }
    .unMergeStatus {
        color: #F22A0E !important;
    }
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    .loader {
      border: 12px solid #f3f3f3;
      border-top: 12px solid #3498db;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      animation: spin 2s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .customPagination ::v-deep .page-link {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none ;
      height: 30px;
      width: 30px;
      margin: 0;
      padding: 10px;
      font-size: 20px;
      color: #9B9B9B;
      margin-left: 10px;
    }
    .customPagination ::v-deep .active .page-link {
      background-color: #005DF1;
      border-radius: 8px;
      color: #FFFFFF;
      margin-left: 10px;
    }
    .pagination.customPagination ::v-deep .page-item:first-child .page-link,
    .pagination.customPagination ::v-deep .page-item:last-child .page-link {
      font-size: 40px !important; /* Adjust the font size as needed */
      padding: 0 20px 10px 20px;
    }
    .navLinks {
        list-style: none;
        display: flex;
        padding-left: 0;
        justify-content: center;
    }
    .navLinks li {
        padding: 10px 35px 10px 0px;
    }
    .linkItem {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #8C8C8C;
    Padding:10px 30px 10px 30px;
    border-radius: 8px;
    }
    .linkItem:hover {
        color: #FFFFFF;
        background-color: #1E90FF;
    }
    .navLinks .active {
    color: #FFFFFF !important;
    background-color: #1E90FF;
    }
    .activitySearch input, .activitySearch select {
      font: 400;
      font-size: 16px;
      color: #1C1B1F;
      border: 1px solid #E4ECF4;
      border-radius: 8px;
      padding: 10px;
      height: 44px !important;
      width: 100%;
    }

    .search-input-wrapper {
      position: relative;
      width: 100%;
    }

    .search-input {
      padding-right: 40px !important;
    }

    .clear-search-btn {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      transition: color 0.2s;
      z-index: 10;
    }

    .clear-search-btn:hover {
      color: #000;
    }

    .clear-search-btn svg {
      width: 16px;
      height: 16px;
    }
    .activityBtn button {
      border-radius: 8px;
      color: #FFFFFF;
      font-weight: 600;
      font-size: 18px;
      background-color: #1E90FF;
      padding: 10px;
      height: 44px;
      width: 160px;
      border: none;
      width: 100%;
    }
    /* MMR Export Drawer Styles */
    .mmrExportDrawerWrapper {
      position: relative;
    }

    .drawer-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1040;
      transition: opacity 0.3s ease;
    }

    .mmrExportDrawer {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      max-width: 500px;
      height: 100%;
      background-color: #ffffff;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
      z-index: 1041;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }

    .mmrExportDrawer.drawer-open {
      transform: translateX(0);
    }

    .drawer-header {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      background-color: #ffffff;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .drawer-header h2 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #000000;
    }

    .drawer-header button {
      font-size: 24px;
      color: #666;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s;
    }

    .drawer-header button:hover {
      color: #000;
    }

    .vehicleInfo {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
    }

    .headerData {
      margin-bottom: 20px;
    }

    .leftData h3 {
      margin: 0 0 10px 0;
      font-size: 20px;
      font-weight: 600;
      color: #000000;
    }

    .metaInfoFlexItem {
      margin-top: 10px;
    }

    .metaInfoFlexItem p {
      margin: 0;
      font-size: 14px;
      color: #666;
    }

    .metaInfoFlexItem p strong {
      color: #000;
      font-weight: 600;
    }

    .rightData {
      display: flex;
      align-items: center;
    }

    /* .exportBtn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;
      border-radius: 4px;
    }

    .exportBtn:hover {
      background-color: #f5f5f5;
    } */
     .exportBtn {
        background-color: #1E90FF;
        color: #ffffff;
        border: none;
        border-radius: 8px;
        padding: 10px;
        height: 44px;
        margin-right: 10px;
        /* width: 100%; */
     }
     .exportBtn.cancelBtn {
        background-color: #6c757d;
     }
     .exportBtn.cancelBtn:hover {
        background-color: #5a6268;
     }
     .historical-export-date-range {
        flex-wrap: wrap;
     }
     .historical-export-date-range .date-input-wrapper {
        min-width: 150px;
     }
     .historical-export-date-range input[type="date"] {
        padding: 10px;
        border: 1px solid #E4ECF4;
        border-radius: 8px;
        font-size: 16px;
        height: 44px;
        width: 100%;
     }

    .exportCalendar {
      margin-top: 20px;
    }

    .commonFomrWrapper {
      width: 100%;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .form-control {
      padding: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      width: 100%;
    }

    .dateRangeBox {
      width: 100%;
    }

    .date-input-wrapper {
      display: flex;
      flex-direction: column;
    }

    .or-divider {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 15px 0;
      position: relative;
    }

    .or-divider::before,
    .or-divider::after {
      content: '';
      flex: 1;
      height: 1px;
      background-color: #e0e0e0;
    }

    .or-text {
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      font-weight: 500;
      background-color: #ffffff;
    }

    .yearMonthBox {
      width: 100%;
    }

    .select-wrapper {
      display: flex;
      flex-direction: column;
    }

    .selectBox {
      width: 100%;
    }

    input[type="date"] {
      width: 100%;
      padding: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      color: #333;
    }

    input[type="date"]:focus {
      outline: none;
      border-color: #005DF1;
      box-shadow: 0 0 0 0.2rem rgba(0, 93, 241, 0.25);
    }

    .drawer-content {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
    }

    .timeline {
      width: 100%;
    }

    .timelineItems {
      position: relative;
      padding-left: 30px;
    }

    .timelineItem {
      position: relative;
      padding-bottom: 30px;
      padding-left: 30px;
    }

    .timelineItem:last-child {
      padding-bottom: 0;
    }

    .timelineMarker {
      position: absolute;
      left: -8px;
      top: 0;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #005DF1;
      border: 3px solid #ffffff;
      box-shadow: 0 0 0 2px #005DF1;
    }

    .timelineItem::before {
      content: '';
      position: absolute;
      left: -2px;
      top: 16px;
      bottom: -10px;
      width: 2px;
      background-color: #e0e0e0;
    }

    .timelineItem:last-child::before {
      display: none;
    }

    .timelineContent {
      background-color: #f9f9f9;
      padding: 15px;
      border-radius: 8px;
      border-left: 3px solid #005DF1;
    }

    .timelineHeader {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 10px;
    }

    .timelineDate {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      line-height: 1.2;
    }

    .timelineValueWrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
      line-height: 1.2;
    }

    .timelineValueLabel {
      font-size: 12px;
      font-weight: 500;
      color: #666;
      /* text-transform: uppercase; */
      letter-spacing: 0.5px;
    }

    .timelineValue {
      font-size: 16px;
      font-weight: 700;
      color: #005DF1;
    }

    .timelineDescription {
      margin: 0;
      font-size: 14px;
      color: #666;
      line-height: 1.5;
    }

    .gap-4 {
      gap: 1rem;
    }

    @media (max-width: 768px) {
      .mmrExportDrawer {
        max-width: 100%;
      }
    }

    /* Filter Button & Dropdown Styles */
    .tableFilterAction {
      display: flex;
      align-items: center;
    }

    .filter-btn-dropdown {
      width: 100%;
      height: 44px;
    }

    .filter-btn-dropdown ::v-deep .btn {
      width: 100%;
      height: 44px;
      border: 1px solid #E4ECF4;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      background-color: #1E90FF;
      color: #ffffff;
      font-weight: 400;
      transition: all 0.2s;
    }

    .filter-btn-dropdown ::v-deep .btn::after {
          display: none;
    }

    .filter-btn-dropdown ::v-deep .btn:hover,
    .filter-btn-dropdown ::v-deep .btn:focus,
    .filter-btn-dropdown ::v-deep .btn:not(:disabled):not(.disabled):active {
      /* background-color: #f5f5f5; */
      /* border-color: #E4ECF4; */
      /* color: #1C1B1F; */
      box-shadow: none;
    }

    .filter-btn-dropdown ::v-deep .dropdown-menu {
      min-width: 400px;
      max-width: 500px;
      padding: 0;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      margin-top: 8px;
    }

    .comm-dropdown.filterMenuOuter {
      padding: 0;
    }

    .form-wrap {
      padding: 20px;
    }

    .filter-header {
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
    }

    .filter-header h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #000000;
    }

    .close-btn {
      /* width: 32px;
      height: 32px; */
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      border: none;
      background: none;
      cursor: pointer;
      padding: 0;
      transition: color 0.2s;
    }

    .close-btn:hover {
      color: #000;
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    .close-btn svg {
      width: 20px;
      height: 20px;
    }

    .form-row {
      margin-bottom: 20px;
    }

    .inputBox {
      width: 100%;
    }

    .selectBox {
      width: 100%;
    }

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .primary-radio {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .primary-radio .form-check {
      display: flex;
      align-items: center;
      margin: 0;
    }

    .primary-radio .form-check-input {
      margin-top: 0;
      margin-right: 8px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    .primary-radio .form-check-label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      margin: 0;
    }

    .primary-radio .form-check-input:checked {
      background-color: #1E90FF;
      /* border-color: #005DF1; */
      border-color: #1E90FF;
    }

    .primary-radio .form-check-input:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 93, 241, 0.25);
      border-color: #005DF1;
    }

    .filterBtnHolder {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #e0e0e0;
    }

    .filterBtnHolder .btn {
      min-width: 100px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 4px;
    }

    .filterBtnHolder .btn-outline-primary {
      border-color: #1E90FF;
      color: #1E90FF;
      background-color: #ffffff;
    }

    .filterBtnHolder .btn-outline-primary:hover {
      /* background-color: #005DF1; */
      background-color: #1E90FF;
      color: #ffffff;
    }

    .filterBtnHolder .btn-primary {
      background-color: #1E90FF;
      border-color: #1E90FF;
      color: #ffffff;
    }

    .filterBtnHolder .btn-primary:hover {
      background-color: #1E90FF;
      border-color: #0047c4;
    }

    .mb-20 {
      margin-bottom: 20px;
    }

    .flex-grow-1 {
      flex-grow: 1;
    }
    .disabled-btn {
      cursor: default;
    }
    .data-availability-text {
      font-size: 13px;
      color: #1E90FF;
      font-weight: 600;
    }
    .total-records-text {
      font-size: 14px;
      color: #2C2C2C;
      font-weight: 400;
    }
    .expand-arrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.3s ease;
      color: #1E90FF;
    }
    .expand-arrow.expanded {
      transform: rotate(90deg);
    }
    .expanded-row {
      background-color: #f9f9f9;
    }
    .expanded-content {
      padding: 20px !important;
      background-color: #f9f9f9;
    }
    .expanded-content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .expanded-table-container {
      width: fit-content;
      overflow-x: auto;
    }
    .expanded-table {
      width: 100%;
      background-color: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      overflow: hidden;
    }
    .expanded-table thead {
      background-color: #E1E4E7;
    }
    .expanded-table thead th {
      padding: 12px;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      border-bottom: 1px solid #dbdbdb;
    }
    .expanded-table tbody td {
      padding: 12px;
      font-size: 14px;
      color: #2C2C2C;
      border-bottom: 1px solid #dbdbdb;
    }
    .expanded-table tbody tr:last-child td {
      border-bottom: none;
    }
    .expanded-controls {
      display: flex;
      /* justify-content: space-between; */
      align-items: center;
      gap: 20px;
      flex-wrap: wrap;
    }
    .radio-buttons-group {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
    .radio-buttons-group .form-check {
      display: flex;
      align-items: center;
      margin: 0;
    }
    .radio-buttons-group .form-check-input {
      margin-top: 0;
      margin-right: 8px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .radio-buttons-group .form-check-label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      margin: 0;
    }
    .radio-buttons-group .form-check-input:checked {
      background-color: #1E90FF;
      border-color: #1E90FF;
    }
    .expanded-action-btn {
      background-color: #1E90FF;
      color: #ffffff;
      border: none;
      border-radius: 8px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s;
    }
    .expanded-action-btn:hover {
      background-color: #005DF1;
    }
    .modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton, .yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}
.yesButton {
  background-color: #6c757d;
}
.yesButton:hover {
  background-color: #5a6268;
}
.mergeButton:hover {
  background-color: #005DF1;
}
.edit-note-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1E90FF;
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s, background-color 0.2s;
  border-radius: 4px;
  flex-shrink: 0;
}
.edit-note-btn:hover {
  color: #005DF1;
  background-color: #f5f5f5;
}
.edit-note-btn svg {
  width: 16px;
  height: 16px;
  position: relative;
  top: 4px;
}
.note-edit-wrapper {
  width: 100%;
  flex-wrap: nowrap;
}
.note-text {
  white-space: normal;
  word-break: break-all; 
}
.note-edit-input {
  flex: 1;
  min-width: 200px;
  height: 36px;
  font-size: 14px;
  padding: 6px 12px;
  border: 1px solid #E4ECF4;
  border-radius: 4px;
}
.note-edit-input:focus {
  outline: none;
  border-color: #1E90FF;
  box-shadow: 0 0 0 0.2rem rgba(30, 144, 255, 0.25);
}
.update-note-btn {
  background-color: #1E90FF;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.update-note-btn:hover {
  background-color: #005DF1;
}
.cancel-note-btn {
  background-color: #6c757d;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.cancel-note-btn:hover {
  background-color: #5a6268;
}

    @media (max-width: 768px) {
      .filter-btn-dropdown ::v-deep .dropdown-menu {
        min-width: 300px;
        max-width: 90vw;
      }
    }
</style>
